module.exports = __webpack_public_path__ + "r-v3/img/stopwatch_pause_not_click.d894c882.svg";